<template>
  <div>
    <Toolbar class="my-md-auto" elevation="0"  :handle-submit="onSendProdFileForm" :handle-reset="resetForm">
      <template v-slot:left>
        <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
          <h1 v-if="!sub"><v-icon large>mdi-file-cad</v-icon>{{$t('designfile.designfiles')}}</h1>
        </v-toolbar-title>
      </template>
    </Toolbar>
    <DesignFileForm ref="createForm" :values="item" :errors="violations" :customer-prop="customer" :type-prop="type"/>
    <Loading :visible="isLoading" />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { createHelpers } from 'vuex-map-fields';
import DesignFileForm from '../../components/designfile/Form';
import Loading from '../../components/Loading';
import CreateMixin from '../../mixins/CreateMixin';
import FileMixin from '../../mixins/FileMixin';
import Toolbar from "@/components/Toolbar.vue";

const servicePrefix = 'DesignFile';

const { mapFields } = createHelpers({
  getterType: 'designfile/getField',
  mutationType: 'designfile/updateField'
});

export default {
  name: 'DesignFileCreate',
  servicePrefix,
  mixins: [CreateMixin,FileMixin],
  components: {
    Toolbar,
    Loading,
    DesignFileForm
  },
  data() {
    return {
      item: {
      }
    };
  },
  computed: {
    ...mapFields(['error', 'isLoading', 'uploaded','created', 'violations']),
  },
  methods: {
    ...mapActions('designfile', ['create','upload', 'reset']),

    onCreated(item) {
      if (item['name']) {
        this.showMessage(`${item['name']} ${this.$t('global.created')}`);
      } else {
        this.showMessage(`${item['@id']} ${this.$t('global.created')}`);
      }

      if (!this.sub){
        this.$router.push({
          name: `${this.$options.servicePrefix}Show`,
          params: { id: item['@id'] }
        });
      }
      this.$emit('close');

    },

    onSendProdFileForm() {
      this.onSendForm();
      this.inputfile = this.item.file;
    }
  },
  props: {
    sub: {
      type: Boolean,
      required: false,
      default: false
    },
    customer: {
      type: [Object, String],
      required: false,
      default: null,
    },
    type: {
      type: Object,
      required: false,
      default: null,
    }
  }
};
</script>
